import { createContext, useContext } from "react";
import type { PeerStatus } from "@/types/peerConnection";
import usePeerConnectionManager from "@/hooks/usePeerConnectionManager";
import type { LanStatus, LanStatusDetail } from "@/hooks/usePeerConnectionManager";

type PeerConnectionManagerReturn = ReturnType<typeof usePeerConnectionManager>;

export type MobilePeerConnectionContextValue = {
  peerConnectionId: string | null;
  peerStatus: PeerStatus;
  peerError: string | null;
  isPeerConnected: boolean;
  isSocketConnected: boolean;
  remoteStream: MediaStream | null;
  remoteStreamVersion: number;
  mobileHasJoined: boolean;
  lanStatus: LanStatus;
  lanStatusDetail: LanStatusDetail;
  isMobileBypassed: boolean;
  markMobileBypassed: PeerConnectionManagerReturn["markMobileBypassed"];
  lanMatchedPeerFailed: boolean;
  sendPeerMessage: PeerConnectionManagerReturn["sendPeerMessage"];
};

const MobilePeerConnectionContext =
  createContext<MobilePeerConnectionContextValue | null>(null);

export const useMobilePeerConnection = () => {
  const context = useContext(MobilePeerConnectionContext);
  if (!context) {
    throw new Error(
      "useMobilePeerConnection must be used within a MobilePeerConnectionContext provider",
    );
  }
  return context;
};

export default MobilePeerConnectionContext;
